import {
  EMPLOYMENT_STATUS,
  TStaffDetailsResponse,
} from '../../apis/staff/staff.interfaces';
import { mockStaffPreviousExperience } from './staffPreviousExperienceMock';
import { GENDER } from '../../apis/users/users.interfaces';
import { mockDocument } from '../documents/documentMock';
import { mockUserAction } from '../users/userAction';

export const mockStaffDetails: TStaffDetailsResponse = {
  id: '4f23999d-c28c-4f17-87c5-d3b90d2b1cde',
  documents: [
    '3fa85f64-5717-4562-b3fc-2c963f66afa6',
    '8f14e45f-ea4d-4f06-8e64-b63403c4a2b7',
    '9a25e56g-fb5e-5g27-9f75-c74514e5b3c8',
  ],
  designation: 'Computer Science Teacher',
  joiningDate: '2023-08-20T00:00:00.000Z',
  department: 'Computer Science',
  employmentStatus: EMPLOYMENT_STATUS.ACTIVE,
  basicDetails: {
    id: '4f23999d-c28c-4f17-87c5-d3b90d2b1cde',
    firstName: 'Ramesh',
    middleName: 'Kumar',
    lastName: 'Agarwal',
    gender: GENDER.MALE,
    profile: {
      profilePicture: mockDocument,
      idProof: mockDocument,
      addressProof: mockDocument,
    },
  },
  addressDetails: {
    _id: '61e7bd57-1283-47d4-9e35-894c14dffc60',
    address1: '123 Mumbai Street',
    address2: 'Apartment 4B',
    city: 'Mumbai',
    state: 'Maharashtra',
    country: 'India',
    postalCode: '400001',
    isCurrent: true,
    description: 'Current residence',
  },
  contactDetails: {
    _id: '23a3a694-0000-4971-8464-b1509e2e8e89',
    phone: {
      countryCode: '+91',
      phoneNumber: '9876543210',
      isVerified: true,
    },
    email: {
      email: 'ramesh.agarwal@institute.edu',
      isVerified: true,
    },
  },
  previousExperience: mockStaffPreviousExperience,
  createdBy: mockUserAction.userId,
  createdAt: '2025-06-01T12:21:54.268Z',
};
